export default __webpack_public_path__ + "static/media/grafema_+-identity_02.c928d637.gif";